import { ReactElement } from 'react';

import { QueueUploadSeismic3DParam } from './params/QueueUploadSeismic3DParam';
import { QueueSeismicItemActions } from './QueueSeismicItemActions';
import { IItemActionsProps, QueueTypeHandler } from '../QueueTypeHandler';

export class UploadSeismic3DHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = ['.sgy', '.segy'];

    renderParams(onParamsChange?: (params: Record<string, unknown>) => void, initialValues?: Record<string, string>): ReactElement {
        return <QueueUploadSeismic3DParam onParamsChange={onParamsChange} initialValues={initialValues} />;
    }

    renderItemActions(props: IItemActionsProps): ReactElement {
        return <QueueSeismicItemActions {...props} />;
    }
}
